<template>
  <svg
    viewBox="0 0 24 27"
    fill="none"
    stroke="currentColor"
    :class="customStyle"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.00709 20.1169C3.8512 19.9821 3.69924 19.8408 3.55149 19.693C-0.133242 16.0084 0.214067 9.68687 4.32724 5.57364C10.5336 -0.632702 21.343 1.90154 21.343 1.90154C21.343 1.90154 22.4368 6.56685 21.4275 11.5273"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.62573 21.6653C7.41972 21.9617 8.25587 22.1437 9.11037 22.2128"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.3793 4.86523C15.4827 6.79624 2.73792 16.1618 2.73792 25.7204"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.5408 16.208C11.625 15.251 12.2202 14.4878 13.1715 14.3532C14.0044 14.2355 15.2836 14.1342 17.2207 14.1342C19.1577 14.1342 20.437 14.2355 21.2699 14.3532C22.2212 14.4878 22.8164 15.251 22.9006 16.208C22.961 16.896 23.0138 17.7795 23.0138 18.7687C23.0138 21.3838 21.6336 23.8308 19.3084 25.0275C18.5316 25.4273 17.7736 25.7204 17.2207 25.7204C16.6678 25.7204 15.9098 25.4273 15.133 25.0275C12.8078 23.8308 11.4276 21.3838 11.4276 18.7687C11.4276 17.7795 11.4804 16.896 11.5408 16.208Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.9034 19.1935L17.0503 21.6653L20.1172 17.0308"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'MeasureIcon',
  props: {
    customStyle: {
      type: String,
      default: 'w-5 h-5',
    },
  },
}
</script>
